// import React from 'react'
// import Typography from '@material-ui/core/Typography'
// import Divider from '@material-ui/core/Divider'

// function Research_Programs() {
// 	return (
// 		<>
// 			<section
// 				style={{
// 					backgroundImage:
// 						'linear-gradient(to right, rgba(0, 30, 51, 1), rgba(0, 80, 138, 1), rgba(0, 30, 51, 1))',
// 					textAlign: 'center',
// 					width: '100%',
// 					height: '55vh',
// 				}}
// 			>
// 				<h1 style={{ color: 'white', padding: '100px', fontSize: '50px' }}>Research Programs</h1>
// 			</section>
// 			<section style={{ backgroundColor: '#F0F0F1' }}>
// 				<div
// 					style={{
// 						borderRadius: ' 20px ',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">&nbsp; &nbsp;DAAD Wise Program&nbsp; &nbsp;</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: Research internships for Students to work in German universities.
// 						<br />
// 						<br />
// 						• Country: Germany
// 						<br />
// 						<br />
// 						• Time Period: Both Summer and Winter alternatives available
// 						<br />
// 						<br />
// 						• Application dates:varies
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates/Undergraduates
// 						<br />
// 						<br />
// 						• Website link: ____
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>

// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;Engineering Vacation Research Internship Program&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By the University of Sydney.
// 						<br />
// 						<br />
// 						• Country: Australia
// 						<br />
// 						<br />
// 						• Time Period: Winter: June to August; Summer: December to February
// 						<br />
// 						<br />
// 						• Application dates:Winter: April; Summer: September/October
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:_____
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>

// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;Adelaide Summer Research Scholarships&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By the University of Adelaide
// 						<br />
// 						<br />
// 						• Country: Austraila
// 						<br />
// 						<br />
// 						• Time Period: Summer period
// 						<br />
// 						<br />
// 						• Application dates:July end to mid-September
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:___
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;Summer and Winter Vacation Research Scholarship Program&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By the Monash University
// 						<br />
// 						<br />
// 						• Country: Austraila
// 						<br />
// 						<br />
// 						• Time Period: Summer and Winter period
// 						<br />
// 						<br />
// 						• Application dates:mid-May to May end
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:___
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;Mitacs Globalink Research Internship&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By Mitacs.
// 						<br />
// 						<br />
// 						• Country: Canada
// 						<br />
// 						<br />
// 						• Time Period: May to October
// 						<br />
// 						<br />
// 						• Application dates:September last week
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">&nbsp; &nbsp;Charpak Lab Scholarship&nbsp; &nbsp;</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By Campus France.
// 						<br />
// 						<br />
// 						• Country: France
// 						<br />
// 						<br />
// 						• Time Period: Summer period
// 						<br />
// 						<br />
// 						• Application dates:mid-December to mid-February
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates/Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;Internship at Unversity of Bordeaux&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By University of Bordeaux.
// 						<br />
// 						<br />
// 						• Country: France
// 						<br />
// 						<br />
// 						• Time Period: varies
// 						<br />
// 						<br />
// 						• Application dates:varies
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates/Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;Yonsei International Summer School&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By Yonsei University.
// 						<br />
// 						<br />
// 						• Country: South Korea
// 						<br />
// 						<br />
// 						• Time Period: Summer period
// 						<br />
// 						<br />
// 						• Application dates:mid-May to May end
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">&nbsp; &nbsp;IUSSTF-Viterbi Program&nbsp; &nbsp;</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By IUSSTF and the Viterbi School of Engineering, University of Southern
// 						California.
// 						<br />
// 						<br />
// 						• Country: United States
// 						<br />
// 						<br />
// 						• Time Period: Summer period
// 						<br />
// 						<br />
// 						• Application dates:mid-January
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates/Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">&nbsp; &nbsp;S.N.Bose Scholars Program&nbsp; &nbsp;</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By IUSSTF and partners.
// 						<br />
// 						<br />
// 						• Country: United States
// 						<br />
// 						<br />
// 						• Time Period: Summer period
// 						<br />
// 						<br />
// 						• Application dates:varies
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates/Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;University of Tokyo Amgen Scholars Program&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By Amgen.
// 						<br />
// 						Engineering Vacation Research Internship Program
// 						<br />
// 						• Country: Japan
// 						<br />
// 						<br />
// 						• Time Period: Summer period
// 						<br />
// 						<br />
// 						• Application dates:varies
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;University of Kyoto Amgen Scholars Program&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: by Amgen.
// 						<br />
// 						<br />
// 						• Country: Japan
// 						<br />
// 						<br />
// 						• Time Period:June to August
// 						<br />
// 						<br />
// 						• Application dates:November first week to February first week
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;Duke Summer Undergraduate Research Program&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By Duke University.
// 						<br />
// 						<br />
// 						• Country: United States
// 						<br />
// 						<br />
// 						• Time Period: May to July
// 						<br />
// 						<br />
// 						• Application dates:December
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;TaiwanInternational Internship Program (IIP)&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By Taiwan International Graduate Program.
// 						<br />
// 						<br />
// 						• Country: Taiwan
// 						<br />
// 						<br />
// 						• Time Period: Summer period
// 						<br />
// 						<br />
// 						• Application dates:April
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;International Visiting Internship Student Program&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By the Hong Kong University of Science and Technology.
// 						<br />
// 						<br />
// 						• Country: Hong Kong
// 						<br />
// 						<br />
// 						• Time Period: Summer period
// 						<br />
// 						<br />
// 						• Application dates:May end
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates/Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">&nbsp; &nbsp;ASPIRE Program&nbsp; &nbsp;</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By the University of Amsterdam.
// 						<br />
// 						<br />
// 						• Country: Netherlands
// 						<br />
// 						<br />
// 						• Time Period: Mid-June to August
// 						<br />
// 						<br />
// 						• Application dates:Mid April
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">&nbsp; &nbsp;ISTernship Summer Program&nbsp; &nbsp;</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By IST Austria.
// 						<br />
// 						<br />
// 						• Country: Austria
// 						<br />
// 						<br />
// 						• Time Period: mid-May to mid-september
// 						<br />
// 						<br />
// 						• Application dates:Mid February
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates/Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">&nbsp; &nbsp;Summer Research Program - NTHU&nbsp; &nbsp;</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By National Tsing Hua University (NTHU).
// 						<br />
// 						<br />
// 						• Country: Taiwan
// 						<br />
// 						<br />
// 						• Time Period:May to July; June to August
// 						<br />
// 						<br />
// 						• Application dates:Mid-November
// 						<br />
// 						<br />
// 						• Eligibility :Postgraduates/Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;Research Internship for Young Academics (RIYA)&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By the Ohio State University.
// 						<br />
// 						<br />
// 						• Country: United States
// 						<br />
// 						<br />
// 						• Time Period: early May to July third week
// 						<br />
// 						<br />
// 						• Application dates:varies
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 				<div
// 					style={{
// 						borderRadius: '20px',
// 						backgroundColor: 'white',
// 						width: '80%',
// 						padding: '30px',
// 						margin: 'auto',
// 						marginTop: '80px',
// 						border: '2.5px solid black',
// 					}}
// 				>
// 					<center>
// 						<Typography variant="h4">
// 							&nbsp; &nbsp;Chemers Neustin Summer Undergraduate Research Fellowship Program&nbsp; &nbsp;
// 						</Typography>
// 					</center>
// 					<Divider />
// 					<Divider />
// 					<br />
// 					<Typography variant="h6">Program Details</Typography>
// 					<br />
// 					<Typography paragraph>
// 						• title: By the Rockfeller University.
// 						<br />
// 						<br />
// 						• Country: United States
// 						<br />
// 						<br />
// 						• Time Period:early June to mid-August
// 						<br />
// 						<br />
// 						• Application dates:early February
// 						<br />
// 						<br />
// 						• Eligibility :Undergraduates
// 						<br />
// 						<br />
// 						• Website link:______
// 						<br />
// 						<br />
// 					</Typography>
// 				</div>
// 			</section>
// 		</>
// 	)
// }

// export default Research_Programs

import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function createData(title,description, country, timeperiod, applicationdates, eligibilty) {
  return { title,description, country, timeperiod, applicationdates, eligibilty };
}

const rows = [
  createData('DAAD Wise Program','Research internships for Students to work in German universities', 'Germany', 'Both Summer and Winter alternatives available', 'varies', 'PG/UG','-'),
  createData('Engineering Vacation Research Internship Program ','By the University of Sydney', 'Australia', ' Winter: June to August; Summer: December to February', 'Winter: April; Summer: September/October', 'UG'),
  createData('Adelaide Summer Research Scholarships',' By the University of Adelaide', 'Austraila', 'Summer period', 'July end to mid-September', 'UG'),
  createData('  Summer and Winter Vacation Research Scholarship Program','By the Monash University', ' Austraila', 'Summer and Winter period', 'mid-May to May end', 'UG'),
  createData('Mitacs Globalink Research Internship ','By Mitacs', 'Canada', 'May to October', 'September last week', 'UG'),
  createData('Charpak Lab Scholarship','By Campus France', 'France', 'Summer period', 'mid-December to mid-February', 'PG/UG'),
  createData(' Internship at Unversity of Bordeaux','By University of Bordeaux', ' France', 'Varies', 'Varies', 'PG/UG'),
  createData('Yonsei International Summer School','By Yonsei University', 'South Korea', 'Summer period', 'mid-May to May end', 'UG'),
  createData('IUSSTF-Viterbi Program ','By IUSSTF and the Viterbi School of Engineering, University of Southern California', 'United States', 'Summer period', 'mid-January', 'PG/UG'),
  createData(' S.N.Bose Scholars Program  ','By IUSSTF and partners', 'United States', 'Summer period','Varies', 'PG/UG'),
  createData('University of Tokyo Amgen Scholars Program','By Amgen Engineering Vacation Research Internship Program', 'Japan', 'Summer period', 'Varies', 'UG'),
  createData(' University of Kyoto Amgen Scholars Program  ','by Amgen', 'Japan', 'June to August', 'November first week to February first week', 'UG'),
  createData('Duke Summer Undergraduate Research Program','By Duke University', 'United States', 'May to July', 'December', 'UG'),
  createData('TaiwanInternational Internship Program (IIP)','By Taiwan International Graduate Program', 'Taiwan', 'Summer period','April', 'PG'),
  createData('International Visiting Internship Student Program','By the Hong Kong University of Science and Technology', 'Hong Kong', 'Summer period', 'May end', 'PG/UG'),
  createData('ASPIRE Program','By the University of Amsterdam', 'Netherlands', 'Mid-June to August', 'Mid April', 'PG'),
  createData('ISTernship Summer Program','By IST Austria', 'Austria', 'mid-May to mid-september', 'Mid February', 'PG/UG'),
  createData('Summer Research Program - NTHU','By National Tsing Hua University (NTHU)', 'Taiwan', 'May to July; June to August', 'Mid-November', 'PG/UG'),
  createData('Research Internship for Young Academics (RIYA)','By the Ohio State University', 'United States', 'early May to July third week', 'Varies', 'UG'),
  createData('Chemers Neustin Summer Undergraduate Research Fellowship Program','By the Rockfeller University', 'United States', 'early June to mid-August', 'early February', 'UG'),
 
];

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

export default function Research_Programs() {
  const classes = useStyles();

  return (
	<>
		<section
			style={{
				backgroundImage:
					'linear-gradient(to right, rgba(0, 30, 51, 1), rgba(0, 80, 138, 1), rgba(0, 30, 51, 1))',
				textAlign: 'center',
				width: '100%',
				height: '50vh',
			}}
		>
			<h1 style={{ color: 'white', padding: '100px', fontSize: '50px' }}>Research Programs</h1>
		</section>
		
		
		<TableContainer component={Paper}>
			<br /><br />
		<Table classtitle
={classes.table} aria-label="customized table">
			<TableHead>
			<TableRow>
				<StyledTableCell>Title</StyledTableCell>
				<StyledTableCell>Description</StyledTableCell>
				<StyledTableCell >Country</StyledTableCell>
				<StyledTableCell >Time Period</StyledTableCell>
				<StyledTableCell >Application dates</StyledTableCell>
				<StyledTableCell >Eligibility </StyledTableCell>
				{/* <StyledTableCell >Website </StyledTableCell> */}
			</TableRow>
			</TableHead>
			<TableBody>
			{rows.map((row) => (
				<StyledTableRow key={row.title
}>
				<StyledTableCell component="th" scope="row">{row.title}</StyledTableCell>
				<StyledTableCell >{row.description}</StyledTableCell>
				<StyledTableCell >{row.country}</StyledTableCell>
				<StyledTableCell >{row.timeperiod}</StyledTableCell>
				<StyledTableCell >{row.applicationdates}</StyledTableCell>
				<StyledTableCell >{row.eligibilty}</StyledTableCell>
				{/* <StyledTableCell >{row.website}</StyledTableCell> */}
				</StyledTableRow>
			))}
			</TableBody>
		</Table>
		</TableContainer>
	</>
  );
}

